import BaseSportScoring from './BaseSportScoring';

class TableTennisScoring extends BaseSportScoring {
  constructor() {
    super('table_tennis');
  }

  get label() { return 'Table Tennis'; }

  /**
   * Deuce wins can only be recorded when both players are at 10 points.
   * We don't have access to the live score here, so we allow the metric
   * and let the UI / operator sanity-check it.
   */
  canRecordMetric(metricKey, _player, _currentScore) {
    return { allowed: true };
  }

  getEventDescription(metric, player) {
    const playerName = player?.name || player?.full_name || player?.username || 'Player';
    const icons = {
      forehandLoopWinner: '➰',
      flickWinner:        '⚡',
      thirdBallAttack:    '🔄',
      smashWinner:        '💥',
      deuceWin:           '🎯',
      serviceAce:         '🏓',
    };
    const icon = icons[metric.key] || '';
    return `${icon} ${playerName} – ${metric.label}`;
  }
}

export default TableTennisScoring;
